import { Text, TextField } from "components/commons";
import styles from "../dry-stock.module.scss";
import { prettifyDryStock } from "utils/pretty.utils";
import Big from "big.js";

export const dryStockMovementMapper = ({ val, isEdit, inventory, setInventory }) => {
  const {
    beginningInventory,
    endingInventory,
    salesInventory,
    returnInventory,
    shiftInventoryId,
    sku,
    product,
    variant,
    type,
    totalQuantityDelivered,
    isBeginningEnabled,
  } = val;

  const initItem = {
    shiftInventoryId: shiftInventoryId ?? 0,
    beginningInventory: beginningInventory ?? 0,
    endingInventory: endingInventory ?? 0,
  };

  const item = inventory.find((item) => item.shiftInventoryId === shiftInventoryId) ?? initItem;

  const computeVariance = (beginning, expectedEnding) => {
    return Number(Big(beginning).minus(expectedEnding));
  };

  const expectedEndingInventory = computeExpectedInventory(
    isEdit ? (item.beginningInventory === "" ? 0 : item.beginningInventory) : beginningInventory,
    totalQuantityDelivered,
    salesInventory,
    returnInventory,
  );

  const variance = computeVariance(
    isEdit ? (item.endingInventory === "" ? 0 : item.endingInventory) : endingInventory,
    expectedEndingInventory,
  );

  const varianceColor = isNaN(variance)
    ? ""
    : variance === 0
      ? "black"
      : variance > 0
        ? "#459d4b"
        : "#f45047";

  const replaceInventoryItem = (id, newItem) => {
    if (inventory) {
      setInventory((prevInventory) =>
        prevInventory.map((item) => (item.shiftInventoryId === id ? newItem : item)),
      );
    } else {
      setInventory([...newItem]);
    }
  };

  const isNumericString = (val) => {
    return typeof val === "string" && /^[0-9]+$/.test(val);
  };

  const trimLeadingZeros = (val) => (typeof val === "string" ? val.replace(/^0+(?!$)/, "") : val);

  return {
    itemCode: (
      <>
        <Text className={styles.content}>{sku ?? "-"}</Text>
      </>
    ),
    product: (
      <>
        <Text className={styles.content}>{product ?? "-"}</Text>
      </>
    ),
    variant: (
      <>
        <Text className={styles.content}>{variant ?? "-"}</Text>
      </>
    ),
    type: (
      <>
        <Text className={styles.content}>{prettifyDryStock(type) ?? "-"}</Text>
      </>
    ),
    actualBeginningInventory: (
      <>
        {isEdit ? (
          <TextField
            disabled={!isBeginningEnabled}
            value={item.beginningInventory}
            onChange={(_, { value }) => {
              if (isBeginningEnabled) {
                if (isNumericString(value) || value === "") {
                  let newItem = item;
                  newItem.beginningInventory = value === "" ? "" : trimLeadingZeros(value);
                  replaceInventoryItem(item.id, newItem);
                }
              }
            }}
            onBlur={(_, { value }) => {
              if (isBeginningEnabled) {
                let newItem = item;
                newItem.beginningInventory =
                  value === "" ? beginningInventory : trimLeadingZeros(value);
                replaceInventoryItem(item.id, newItem);
              }
            }}
          />
        ) : (
          <Text className={styles.content}>{beginningInventory}</Text>
        )}
      </>
    ),
    delivery: (
      <>
        <Text className={styles.content}>{totalQuantityDelivered}</Text>
      </>
    ),
    sales: (
      <>
        <Text className={styles.content}>{salesInventory}</Text>
      </>
    ),
    returns: (
      <>
        <Text className={styles.content}>{returnInventory}</Text>
      </>
    ),
    expectedEndingInventory: (
      <>
        <Text className={styles.content}>{expectedEndingInventory}</Text>
      </>
    ),
    actualEndingInventory: (
      <>
        {isEdit ? (
          <TextField
            value={item.endingInventory ?? 0}
            onChange={(_, { value }) => {
              if (isNumericString(value) || value === "") {
                let newItem = item;
                newItem.endingInventory = value === "" ? "" : trimLeadingZeros(value);
                replaceInventoryItem(item.id, newItem);
              }
            }}
            onBlur={(_, { value }) => {
              let newItem = item;
              newItem.endingInventory = value === "" ? endingInventory : trimLeadingZeros(value);
              replaceInventoryItem(item.id, newItem);
            }}
          />
        ) : (
          <Text className={styles.content}>{endingInventory}</Text>
        )}
      </>
    ),
    variance: (
      <>
        <Text color={varianceColor}>{variance}</Text>
      </>
    ),
  };
};

export const computeExpectedInventory = (beginning, delivery, sales, returnInv) => {
  return Number(Big(beginning).add(delivery).minus(sales).add(returnInv));
};
